import { useContext } from 'react';

import { ApiContext } from '../../providers';

export const useAPI = () => {
    const { Upscore, Altinn, Storyblok, Onescore } = useContext(ApiContext);

    return { Upscore, Altinn, Storyblok, Onescore };
};
